import React from 'react'
import { Form, Input, Button } from 'antd';
import { MailOutlined, HomeOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const PageContainer = styled.div`
  background-image: url('/authbgimage.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  position: relative;

  /* Gradient colour overlay on top of the photo */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      hsla(210, 55%, 22%, 0.88) 0%,
      hsla(210, 70%, 15%, 0.92) 100%
    );
    pointer-events: none;
  }
`

const FormContainer = styled.div`
  margin: 0 auto;
  width: 28rem;
  max-width: 90vw;
  position: relative;
  z-index: 2;
  background-color: #1A1A1A;
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
`

const FormWrapper = styled.div`
  padding: 48px 40px;
`

const FormTitle = styled.h2`
  margin: 0px 0px 8px 0px;
  color: white;
  font-size: 2.5rem;
  font-weight: 500;
  text-align: center;
`

const FormSubtitle = styled.p`
  color: #9CA3AF;
  font-size: 0.875rem;
  margin-bottom: 2rem;
  text-align: center;
`

const StyledForm = styled(Form)`
  .ant-input-affix-wrapper {
    background: rgba(255, 255, 255, 0.1) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-radius: 6px !important;

    .ant-input {
      background: transparent !important;
      color: white !important;
      border: none !important;

      &::placeholder {
        color: rgba(255, 255, 255, 0.6) !important;
      }
    }

    .ant-input-prefix {
      color: rgba(255, 255, 255, 0.6) !important;
    }

    &:hover, &:focus, &.ant-input-affix-wrapper-focused {
      border-color: hsl(33, 100%, 50%) !important;
      box-shadow: 0 0 0 2px rgba(250, 118, 255, 0.2) !important;
    }
  }

  .ant-btn-primary {
    background: hsl(33, 100%, 50%) !important;
    border-color: hsl(33, 100%, 50%) !important;
    color: black !important;
    font-weight: 500 !important;
    text-transform: uppercase !important;
    font-size: 0.875rem !important;
    height: 48px !important;
    border-radius: 6px !important;

    &:hover {
      background: hsl(33, 100%, 60%) !important;
      border-color: hsl(33, 100%, 60%) !important;
    }
  }
`

const ForgetPassword = () => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log('Received values of form: ', values);
  };

  return (
    <PageContainer>
      <FormContainer>
        <FormWrapper>
          <StyledForm
            form={form}
            name="forget-password"
            onFinish={onFinish}
            scrollToFirstError
          >
            <FormTitle>Reset Password</FormTitle>
            <FormSubtitle>Enter your email address and we'll send you a link to reset your password</FormSubtitle>

            <Form.Item
              name="email"
              rules={[
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!',
                },
                {
                  required: true,
                  message: 'Please input your E-mail!',
                },
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="E-Mail" />
            </Form.Item>

            <Form.Item>
              <Button block type="primary" htmlType="submit">
                Send Reset Link
              </Button>
            </Form.Item>

            <div style={{ textAlign: 'center', marginTop: '1.5rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px' }}>
              <Link to="/login" style={{ color: 'hsl(33, 100%, 50%)', textDecoration: 'none' }}>
                Back to Sign In
              </Link>
              <span style={{ color: '#4B5563' }}>|</span>
              <Link to="/" style={{ color: '#9CA3AF', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                <HomeOutlined /> Return to Home
              </Link>
            </div>
          </StyledForm>
        </FormWrapper>
      </FormContainer>
    </PageContainer>
  );
};

export default ForgetPassword;